import ef from 'ef/ef';
import ContentProvider from 'services/content-provider';
import Assessment from 'ef/models/assessments/assessment';

const AssessmentService = {
  initialize: function (assessmentMap = {}) {
    this.mapping = assessmentMap;
    this.ContentProvider = ContentProvider;
  },

  getAssessment: function (courseSlug) {
    let slug;
    try {
      slug = ef.options.local ? courseSlug : this.getAssessmentActivity(courseSlug).slug;
    } catch (e) {
      slug = courseSlug;
    }

    return new Assessment({ slug: slug });
  },

  getUrl: function (courseSlug) {
    const activity = this.getAssessmentActivity(courseSlug);
    const redirectPath =
      `${window.location.pathname}${window.location.search}` +
      `#${ef.module.currentActivity.currentPage.path()}?assessmentTaken=true`;
    let url = '/assessments/attempts/:assessment_slug?redirect_url=:redirect_url';
    url = url.replace(':assessment_slug', activity.slug);
    url = url.replace(':redirect_url', encodeURIComponent(redirectPath));
    return url;
  },

  getBestScore: async function (courseSlug) {
    if (ef.options.local) {
      return this.ContentProvider.AssessmentService.getBestScore(courseSlug, this.mapping);
    } else {
      return await this.ContentProvider.AssessmentService.getBestScore(courseSlug, this.mapping);
    }
  },

  getAssessmentStatus: function (courseSlug) {
    return this.ContentProvider.AssessmentService.getAssessmentStatus(courseSlug, this.mapping);
  },

  getAssessmentActivity: function (courseSlug) {
    return this.ContentProvider.AssessmentService.getAssessmentActivity(courseSlug, this.mapping);
  },

  userHasCompletedAssessment: function (courseSlug) {
    return this.ContentProvider.AssessmentService.userHasCompletedAssessment(courseSlug, this.mapping);
  },

  getActivityProgressForSlug: function (courseSlug) {
    return this.ContentProvider.AssessmentService.getActivityProgressForSlug(courseSlug, null, this.mapping);
  },
};

export default AssessmentService;
